import { Badge, DropdownMenuItem, DropdownMenuSeparator } from "@myela/ui";
import { leaveDemoUrl } from "@/lib/dashboard";

// Shown only while the session's organization is Myela Demo (the org's `demo=true`, read by the API).

/** The quiet tag beside the lockup. */
export function DemoTag() {
  return <Badge variant="secondary">Demo</Badge>;
}

/** The first line of the lockup menu: a plain link to the Dashboard's org switcher. */
export function LeaveDemoItem() {
  return (
    <>
      <DropdownMenuItem asChild>
        <a href={leaveDemoUrl()}>
          <span className="text-muted-foreground">You're in Myela Demo ·</span>
          <span className="font-medium">Leave demo</span>
        </a>
      </DropdownMenuItem>
      <DropdownMenuSeparator />
    </>
  );
}
